import React, { FunctionComponent, useState, useEffect } from 'react'
import { ISelectOption } from 'Frontend/scripts/models/forums.model'
import Select, { MultiValue, StylesConfig } from 'react-select'

interface MultiSelectProps {
  inputId?: string
  options?: ISelectOption[]
  value?: MultiValue<ISelectOption>
  onChange: (value: MultiValue<ISelectOption>) => void
  addToUrl?: boolean
  id?: string
  placeholderText?: string
  callback?: (_selectedTagIds: string[]) => void | null
}

const MultiSelectComponent: FunctionComponent<MultiSelectProps> = ({
  inputId,
  options,
  value,
  onChange,
  addToUrl,
  placeholderText,
  callback,
}) => {
  const url = new URL(window.location.href)
  const [preSelectedOptions, setPreSelectedOptions] = useState<MultiValue<ISelectOption>>([])

  const handleChange = (selected: MultiValue<ISelectOption>) => {
    onChange(selected)
    const selectedTagIds = selected ? selected.map((opt) => opt.value) : []
    if (addToUrl) {
      url.searchParams.set('tags', selectedTagIds.join(','))
      window.history.pushState({}, '', url)
    }
    setPreSelectedOptions(selected || [])
    callback && callback(selectedTagIds)
  }

  const colourStyles: StylesConfig<any, true> = {
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: '#542361',
        borderRadius: '.4rem',
      }
    },
    multiValueLabel: (styles) => ({
      ...styles,
      color: '#fff',
      fontSize: '1.4rem',
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: '#fff',
    }),
    placeholder: (styles) => ({
      ...styles,
      fontSize: '1.4rem',
      color: '#515658',
    }),
    option: (styles) => ({
      ...styles,
      fontSize: '1.4rem',
    }),
  }

  useEffect(() => {
    const optionsParams = url.searchParams.get('tags')
    if (optionsParams) {
      const valuesFromUrl = optionsParams.split(',')
      const selectedFromUrl = options?.filter((opt) => valuesFromUrl.includes(opt.value))
      setPreSelectedOptions(selectedFromUrl as ISelectOption[])
    } else if (value && value?.length != 0) {
      setPreSelectedOptions(value)
    }
  }, [])

  return (
    <Select
      inputId={inputId}
      options={options}
      isMulti
      classNamePrefix="multi-select"
      onChange={handleChange}
      styles={colourStyles}
      placeholder={placeholderText ? placeholderText : 'Filtrera efter kategoritagg'}
      value={preSelectedOptions}
    ></Select>
  )
}

export default MultiSelectComponent
